module.exports = __webpack_public_path__ + "static/media/kite1920.43da4f99.png";